/**
 * Auth layout — wraps /login and /onboarding.
 *
 * If the user is already authenticated we bounce them to the main app.
 * Otherwise we render the auth child route in a centered, mobile-first
 * frame that also reads well on desktop (max-width 420 px).
 */

import type { ReactNode } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '@turnifly/shared/stores'

export function AuthLayout(): ReactNode {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="min-h-dvh flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-[420px]">
        <Outlet />
      </div>
    </div>
  )
}
